import { getLogger } from '@ravago/shared/logging/client';
import RevalidationTag from '@ravago/shared/page-data/enums/revalidation-tags/tags';
import { ContentfulCollectionName } from '@ravago/shared/page-data/models/contentful';
import { TypeSegmentFields } from '@ravago/shared/page-data/models/contentful-generated';
import { NormalizedCollection, NormalizedSegment } from '@ravago/shared/page-data/models/contentful-mapped';
import { BaseQuery } from '@ravago/shared/page-data/models/utils';
import { ContentfulUtils } from '@ravago/shared/page-data/utils/contentful';
import { DataMapperUtils } from '@ravago/shared/page-data/utils/data-mapper';
import { validateAndFilterSegmentEntries } from '@ravago/shared/page-data/validators';

import { ContentfulClientApi } from 'contentful';

import { cache } from '../cache/cache.utils';
import { createClient } from '../contentful/client';
import { QueryBuilder } from '../query-builder/query-builder';

/* c8 ignore star t */
export class MarketSegmentUtils {
  static getMarketSegments = cache(async (locale: string, query: BaseQuery, overwriteClientApi?: ContentfulClientApi): Promise<NormalizedCollection<NormalizedSegment>> => {
    const [industryId] = query.industryIds || [];
    const contentfulClientApi = overwriteClientApi ?? createClient([RevalidationTag.markets]);

    if (!industryId) return ContentfulUtils.getDefaultCollection();

    const contentType: ContentfulCollectionName = 'segment';

    const { limit, orderBy } = query;

    const queryOptions = new QueryBuilder()
      .contentType(contentType)
      .limit(limit || 4)
      .order(orderBy)
      .include(10)
      .locale(locale)
      .setOptional('fields.industry.sys.id', industryId)
      .build();

    try {
      const entries = await contentfulClientApi.getEntries<TypeSegmentFields>(queryOptions);

      if (!entries.total) return ContentfulUtils.getDefaultCollection();

      const validEntries = validateAndFilterSegmentEntries(entries.items);

      entries.items = validEntries;

      return DataMapperUtils.normalizeContentfulCollection<NormalizedCollection<NormalizedSegment>>(entries, DataMapperUtils.normalizeContentfulSegment);
    } catch (error) {
      getLogger().error(error instanceof Error ? error.message : 'Unknown error occurred.');

      return ContentfulUtils.getDefaultCollection();
    }
  });
}

/* c8 ignore en d */
